var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":"","color":"white","opacity":"1"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"32"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }